window.toastr = require('toastr');

toastr.options = {
    closeButton: true,
    debug: false,
    positionClass: 'toast-top-full-width',
    showMethod: 'slideDown',
    showDuration: '300',
    hideDuration: '100',
    timeOut: '4000',
};
